<template>
    <div id="quiz" >
        <div class="ebookHeader">
            <div style="margin-top:10px;"><a href="#" @click="backToIndex" class="backBtn backBtn-eBook">Back</a></div>
            <div style="margin-top:100px;">
                <audio v-if="audio" :src="audio" controls></audio>
            </div>
        </div>
        <div v-if="questions.length>0" style="margin: auto auto">
            <div style="width:60%;text-align:left;margin: auto auto; margin-top: 20px;">
                <div style="font-size:40px;margin-bottom:100px;" v-html="questions[index].title"></div>
                <div v-if="detail">
                    <div v-for="(choice,i) of questions[index].choices.items" :key="i" style="display:flex;flex-direction:row;">
                        <div style="padding:10px;margin:20px 0px;cursor:pointer;width:80%;display:flex;flex-direction:row;font-size:35px;color:black"
                        :style="{background : questions[index].choices.answer == characters[i] ? 'green' : answer == i ? 'red' : '#ececec'}" @click="selectAnswer(i)">
                            <div>{{characters[i]+". "}}</div>
                            <div style="width:100%;">{{choice}}</div>
                        </div>
                        <img style="transform:scale(1.0);margin:0px 20px;" v-if="questions[index].choices.answer == characters[i]" src="/images/quiz/right.png">
                        <img style="transform:scale(1.0);margin:0px 20px;" v-else-if="answer == i" src="/images/quiz/wrong.png">
                    </div>
                </div>
                <div v-else>
                    <div v-for="(choice,i) of questions[index].choices.items" :key="i" @click="selectAnswer(i)" style="padding:10px;margin:20px 0px;cursor:pointer;" 
                    :style="{background : answer == i ? '#EEC211' : '#ececec'}">
                        <span style="font-size:35px;color:black">{{characters[i]+". "+choice}}</span>
                    </div>
                    <div @click="submit" style="text-align:right;margin:100px 20px;"><el-button :disabled="!readyToSubmit" style="font-size:40px;font-family:'Times New Roman', Times, serif;" size="medium" type="primary">submit</el-button></div>
                </div>

            </div>
            <div style="font-size:40px; position:absolute;right:20px;top:20px;">
                <div>{{(index+1) + "/" + questions.length}}</div>
            </div>
            <div v-if="index != 0" style="position:absolute;left:50px;bottom:50px;transform: scale(1.2);text-align:center;">
                <img  src="/images/listen/last.png" @click="last" />
                <div>上一题</div>
            </div>
            <div  v-if="index != questions.length-1" style="position:absolute;right:50px;bottom:50px;transform: scale(1.2);text-align:center;">
                <img src="/images/listen/next.png"  @click="next"/>
                <div>下一题</div>
            </div>
        </div>
        <el-dialog title="Result" :visible.sync="dialogResultVisible" @close="close">
            <div style="border:1px solid gray;border-radius: 10px;">
                <h1  style="text-align: center;">{{"击败了 "+defeatNumber+"% 的小伙伴"}}</h1>
                <div  style="margin:10px;">
                    <el-row justify="space-between">
                        <el-col :span="12" style="font-size:30px;color:#c53931;text-align: center;">Total</el-col>
                        <el-col :span="12" style="text-align:center;color:green;font-size: 30px;">{{questions.length}}</el-col>
                    </el-row>
                </div>
                <div  style="margin:10px;">
                    <el-row justify="space-between">
                        <el-col :span="12" style="font-size:30px;color:#c53931;text-align: center;">Right</el-col>
                        <el-col :span="12" style="text-align:center;color:green;font-size: 30px;">{{right}}</el-col>
                    </el-row>
                </div>
                
                <div  style="margin:10px;">
                    <el-row justify="space-between">
                        <el-col :span="12" style="font-size:30px;color:#c53931;text-align: center;">Wrong</el-col>
                        <el-col :span="12" style="text-align:center;color:green;font-size: 30px;">{{questions.length-right}}</el-col>
                    </el-row>
                </div>
                <div  style="margin:10px;">
                    <el-row justify="space-between">
                        <el-col :span="12" style="font-size:30px;color:#c53931;text-align: center;">Accuracy</el-col>
                        <el-col :span="12" style="text-align:center;color:green;font-size: 30px;">{{parseInt(right*100/questions.length)+"%"}}</el-col>
                    </el-row>
                </div>
            </div>
            
            
            <div slot="footer" style="text-align: center;">
                <el-button @click="seeDetail" style="font-family: 'Times New Roman', Times, serif;font-size:30px">detail</el-button>
                <el-button @click="close" style="font-family: 'Times New Roman', Times, serif;font-size:30px">got it</el-button>
            </div>
         </el-dialog>
    </div>
</template>

<script>

export default {
    name : 'quiz',
    data(){
        return {
            fullscreenLoading : false,
            questions : [],
            index : -1,
            characters : ['A','B','C','D','E','F','G','H','I','J','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','X'],
            answers : [],
            answer : null,
            defeatNumber : 100,
            dialogResultVisible : false,
            startTime : 0,
            readyToSubmit : false,
            right : 0,
            detail : false,
            audio : null,
            unit : null
        }
    },
    watch : {
        index : function(val){
            this.answer = this.answers[val];
        }
    },
    methods:{
        seeDetail(){
            this.detail = true;
            this.index = 0;
            this.readyToSubmit = false;
            this.dialogResultVisible = false;
        },
        close : function(){
            if(this.detail){
                return;
            }
            this.dialogResultVisible = false;
            this.backToIndex();
        },
        selectAnswer : function(index){
            if(this.detail)
                return;
            this.answer = index;
            this.answers[this.index] = index;
            let i = 0;
            while(i < this.answers.length){
                if(this.answers[i] == -1){
                    break;
                }
                ++i;
            }
            if(i == this.questions.length){
                this.readyToSubmit = true;
            }
        },
        backToIndex : function(){
            this.$router.push("index")
        },
        next : function(){
            this.index++;
        },
        last : function(){
            this.index--;
        },
        submit : function(){
          if(this.readyToSubmit == false){
            this.$message("还有题目没有选择答案哦～");
            return ;
          }
            let _this = this;
            let wrongAnswers = [];
            for(let i=0; i<_this.answers.length; i++){
                if(_this.questions[i].choices.answer != String.fromCharCode(65+_this.answers[i])){
                    wrongAnswers.push({
                        id : _this.questions[i].id,
                        answer : String.fromCharCode(65+_this.answers[i]) + ". "+_this.questions[i].choices.items[_this.answers[i]]
                    })
                }else{
                    _this.right++;
                }
            }
            let accuracy = parseInt(this.right*100/this.questions.length);
            let spend = parseInt((new Date().getTime() - _this.startTime.getTime())/1000);
            _this.request("POST","/test/quiz",{
                startTime : _this.startTime,
                spendSeconds : spend,
                mode : 'quiz',
                result : accuracy,
                unitId : _this.unit.id,
                wrongAnswers : wrongAnswers
            },function(){
                _this.request("GET","/test/defeat", {
                    params : {
                        spendSeconds : spend,
                        result : accuracy,
                        type : 'quiz',
                        unitId : _this.unit.id
                    }
                },function(data){
                    _this.defeatNumber = data;
                    _this.dialogResultVisible = true;
                })
            })
        }
    },
    mounted : function(){
        let _this = this;
        _this.unit = _this.$route.params.unit;
        if(_this.unit == null){
            _this.unit = JSON.parse(localStorage.getItem("quiz-current-unit"));
        }else{
            localStorage.setItem("quiz-current-unit", JSON.stringify(_this.unit));
        }
        let path;
        if(_this.$route.params.notebook){
            path = "/test/notebook/"+_this.$route.params.testId+"/quiz";
        }else{
            path = "/unit/"+_this.unit.id+"/questions";
        }
        _this.request("GET",path, null,function(data){
            if(data == null || data.length == 0){
                _this.$alert("未录入选择题，请联系管理员")
                _this.$router.go(-1);
                return;
            }
            for(let i in data){
                data[i].choices = JSON.parse(data[i].choices);
                data[i].title =  data[i].title.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ');
                if(data[i].choices==undefined  || data[i].choices.items == null || data[i].choices.items.length == 0){
                    continue;
                }
                _this.answers.push(-1)
                _this.questions.push(data[i]);
            }
            _this.index = 0;
            _this.startTime = new Date();    
        });
        
    }
}
</script>

<style>
#quiz{
    position:absolute;
    top:0px;
    left:0px;
    width:100%;
    height:100%;
    background: white url(/images/mode/bg.png) repeat fixed top;
    font-family: 'Times New Roman', Times, serif;
}
</style>